function SummaryCards({ cards, activeKey = 'activas', onSelect = () => {} }) {
  return (
    <div className="summary-grid">
      {cards.map(card => {
        const isInteractive = Boolean(card.key);
        const isActive = isInteractive && activeKey === card.key;
        const classNames = ['summary-card'];
        if (isActive) classNames.push('active');
        if (isInteractive) classNames.push('clickable');

        const handleClick = () => {
          if (!isInteractive) return;
          onSelect(card.key);
        };

        const handleKeyDown = event => {
          if (!isInteractive) return;
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onSelect(card.key);
          }
        };

        return (
          <article
            key={card.label}
            className={classNames.join(' ')}
            tabIndex={isInteractive ? 0 : -1}
            role={isInteractive ? 'button' : 'presentation'}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
          >
            <p className="label">{card.label}</p>
            <h2>{card.value}</h2>
            <span>{card.trend}</span>
          </article>
        );
      })}
    </div>
  );
}

export default SummaryCards;
